<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="actionUrl"
  id="subscription-form"
  :reset="true"
  v-on:submit.prevent="submit"
>
  <div class="form-group">
    <label for="subscription-email">
      Subscriber Email
    </label>
    <input
      type="email"
      name="subscription[email]"
      id="subscription-email"
      v-model="email"
      class="form-control"
    />
  </div>

  <div class="form-group">
    <label for="purchasable_item_id">
      Subscription
    </label>

    <select
      name="subscription[purchasable_item_id]"
      v-model="purchasable_item_id"
      class="form-control"
    >
     <option value="">Select Subscription</option>
      <option
        :selected="item.id === purchasable_item_id"
        :value="item.id"
        v-for="item in purchasable_items"
      >
        {{ item.name }}
      </option>
    </select>

    <p
      class="alert alert-warning text-center"
      role="alert"
    >
      Changing the subscription will set 'Ends At' to correspond with the subscription duration.
    </p>
  </div>

  <div class="form-group row">
    <div class="col">
      <label for="subscription-start-ts">
        Starts At
      </label>
      <input
        type="datetime-local"
        name="subscription[start_ts]"
        id="subscription-start-ts"
        v-model="formattedStartTs"
        class="form-control"
      />
    </div>
    <div class="col">
      <label for="subscription-end-ts">
        Ends At
      </label>
      <input
        type="datetime-local"
        name="subscription[end_ts]"
        id="subscription-end-ts"
        v-model="formattedEndTs"
        class="form-control"
      />
    </div>
  </div>

  <button
    type="submit"
    class="form-control btn btn-primary"
  >
    {{ actionLbl }} Subscription
  </button>
</form>
</template>

<script>
import SubscriptionStore from '@/stores/SubscriptionStore'

export default {
  data () {
    let state = SubscriptionStore.state
    state.query = undefined

    return state
  },

  computed: {
    actionLbl () {
      return this.subscriptionId ? 'Edit' : 'Create'
    },

    actionUrl () {
      return this.apiUrl(
        '/subscriptions' + (
          this.subscriptionId ? ('/' + this.subscriptionId) : ''
        ), true
      )
    },

    methodType () {
      return this.subscriptionId ? 'PUT' : 'POST'
    },

    formattedStartTs: {
      get () {
        return this.$root.dateTimeLocalFmt(this.start_ts)
      },

      set () {
        this.start_ts = this.start_ts || this.$root.dateTimeLocalFmt(this.start_ts)
      }
    },

    formattedEndTs: {
      get () {
        if (this.end_ts) {
          return this.$root.dateTimeLocalFmt(this.end_ts)
        }
      },

      set () {
        if (this.end_ts) {
          this.end_ts = this.end_ts || this.$root.dateTimeLocalFmt(this.end_ts)
        }
      }
    }
  },

  props: [
    'subscriptionId'
  ],

  created () {
    if (this.subscriptionId) {
      this.get()
    }
  },

  methods: {
    get () {
      // get subscriptions for editing.
      this.getSubscriptions().then((items) => {
        this.apiGet('/subscriptions/' + this.subscriptionId, SubscriptionStore, true).then((resp) => {
          this.purchasable_items = items
        })
      }, this.processErrors)
    },

    getSubscriptions () {
      return this.apiGet('/subscription_items?page[size]=500&page[order_by]=name', null, true)
    },

    addPurchasableItem () {
      const select = document.getElementById('found-purchasable-items')
      const option = select.options[select.selectedIndex]

      const item = {
        name: option.text,
        id: option.value,
        price: option.dataset.price
      }

      this.gross = (this.gross || 0) + parseFloat(item.price)

      SubscriptionStore.state.purchasable_item = item
    },

    submit (ev) {
      this.bindSubmit(ev).then((resp) => {
        const sid = resp.body.data.id

        this.$router.push({
          name: 'subscription',
          params: {
            subscriptionId: sid
          }
        })
      }, (errs) => {
        this.processErrors(errs)
        this.$parent.$emit('processErrors', errs)
      })
    },

    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SubscriptionForm.vue